import React, { useState } from 'react';
import { Box, Container, Typography, Button, Snackbar, Alert } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Download as DownloadIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import DatePickerField from '../components/common/DatePickerField';
import { relatoriosSaidaService } from '../services/relatoriosSaida';

const RelatorioVendasPorPeriodoLinha: React.FC = () => {
  const navigate = useNavigate();
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' as 'info' | 'error' });

  const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleGerar = async () => {
    if (!dataInicio || !dataFim) {
      setSnackbar({ open: true, message: 'Informe o período de retorno.', severity: 'error' });
      return;
    }
    setLoading(true);
    setSnackbar({ open: true, message: 'Gerando arquivo para impressão. Aguarde!', severity: 'info' });
    try {
      const blob = await relatoriosSaidaService.imprimirVendasPorPeriodoPorLinha({
        dataInicioCobranca: dataInicio,
        dataFimCobranca: dataFim,
      });
      downloadBlob(blob, `${dataInicio}_${dataFim}_vendas_por_linha.xlsx`);
      setSnackbar({ open: true, message: 'Relatório gerado com sucesso.', severity: 'info' });
    } catch (error: any) {
      setSnackbar({ open: true, message: 'Erro ao gerar relatório: ' + (error.message || error), severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleVoltar = () => {
    navigate('/Relatorios');
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Vendas por Período (Agrupado por Linha)
        </Typography>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={handleVoltar}>
          Voltar
        </Button>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400 }}>
        <DatePickerField label="Data início retorno" value={dataInicio} onChange={setDataInicio} />
        <DatePickerField label="Data fim retorno" value={dataFim} onChange={setDataFim} />

        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleGerar} disabled={loading}>
            Gerar relatório
          </Button>
          <Button variant="outlined" onClick={handleVoltar} disabled={loading}>
            Voltar
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default RelatorioVendasPorPeriodoLinha;
